import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { toast } from "react-toastify";
// import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import { formatDateTime } from "../common-data/Converts";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { commonUpdate } from "../../redux/reducers/putApiSlice";
import { deleteUpdateLead } from "../../data/ApiEndpoints";
import Loader from "../ui/Loader";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import LeadEditForm from "./LeadEditForm";
import LeadFollowupV1 from "./followup/LeadFollowupV1";
import LeadsLogsCard from "./fully-customised/LeadsLogsCard";
import LeadTbCards from "./LeadTbCards";
import AssignForm from "./raw-leads/AssignForm";
import CallDetail from "./call-detail/CallDetail";
import ModalCloseStart from "../payouts-wtf/common/ModalCloseStart";
import LeadDetails from "./detailed-logs/LeadDetails";
import {
  BinIcon,
  EditIcon,
  EyeIcon,
  CallIcon,
  PersonIcon,
  EmailIcon,
  EditIcon1,
  BinIcon1,
  ReloadIcon,
} from "../../images/icons/icons";
import LeadJourney from "./lms-v2/lead-journey/LeadJourney";
import ClickToCall from "./lms-v2/lms-payment-links/ClickToCall";
import CommonTable from "../common-components/common-tables/CommonTable";

const LeadLogsTable = ({
  userInfoData,
  allDatas,
  setAllDatas,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  callFunction,
  tableRef,
  mobileTableRef,
  prevFilters,
}) => {
  const dispatch = useDispatch();
  const { allLeadsLoading } = useSelector((state) => state.api);
  const { loading } = useSelector((state) => state.putApi);

  const isAdmin = userInfoData?.account_type === "admin";
  const isMarketing = userInfoData?.account_type === "marketing";

  const iniClickValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [clickValues, setClickValues] = useState(iniClickValues);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isAllSelectedDisabled, setIsAllSelectedDisabled] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  function onCloseModal() {
    setClickValues(iniClickValues);
  }

  const handleDelete = async (payload) => {
    if (payload?.lead_id && payload.status) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonUpdate({
              endPoint: deleteUpdateLead,
              requestBody: payload,
              filters: "",
              TOKEN: userInfoData?.token,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Lead is deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete Lead!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete Lead");
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure, you want to delete this Lead!`
      );
    } else {
      toast.error("Lead Id required!");
    }
  };

  const handleToggleAllClick = (event) => {
    const isChecked = event.target.checked;

    const updatedRows = allDatas.allLeads.map((row) => {
      const isConvertedOrClosed =
        row?.lead_status?.toLowerCase() === "converted" ||
        row?.lead_status?.toLowerCase() === "closed";

      return {
        ...row,
        checked: isConvertedOrClosed ? false : isChecked,
      };
    });

    const selectedRows = isChecked
      ? updatedRows.filter(
          (row) =>
            !(
              row?.lead_status?.toLowerCase() === "converted" ||
              row?.lead_status?.toLowerCase() === "closed"
            )
        )
      : [];

    setSelectedRows(selectedRows);
    setIsAllSelected(isChecked);

    allDatas.allLeads = updatedRows;
  };

  const handleCheckboxChange = (event, row) => {
    const isChecked = event.target.checked;

    const updatedRows = allDatas.allLeads.map((r) =>
      r.lead_id === row.lead_id ? { ...r, checked: isChecked } : r
    );

    setSelectedRows(
      isChecked
        ? [...selectedRows, { ...row, checked: isChecked }]
        : selectedRows.filter(
            (selectedRow) => selectedRow.lead_id !== row.lead_id
          )
    );

    allDatas.allLeads = updatedRows;
  };

  useEffect(() => {
    const allConvertedOrClosed = allDatas.allLeads.every(
      (row) =>
        row?.lead_status?.toLowerCase() === "converted" ||
        row?.lead_status?.toLowerCase() === "closed"
    );

    if (allConvertedOrClosed) {
      setIsAllSelectedDisabled(true);
    } else {
      setIsAllSelectedDisabled(false);
    }
  }, [allDatas.allLeads]);

  const tbColumns = [
    !isMarketing && {
      dataField: "select",
      text: (
        <input
          type="checkbox"
          className="pp-checkbox"
          checked={isAllSelected}
          onChange={(event) => handleToggleAllClick(event)}
          aria-label="Select all leads"
          disabled={isAllSelectedDisabled}
        />
      ),
      formatter: (_, row) => {
        const isDisabled =
          row?.lead_status?.toLowerCase() === "closed" ||
          row?.lead_status?.toLowerCase() === "converted";

        return (
          <input
            type="checkbox"
            className="pp-checkbox"
            checked={row.checked || false}
            onChange={(event) => handleCheckboxChange(event, row)}
            aria-label={`Select ${row.name}`}
            disabled={isDisabled}
          />
        );
      },
    },
    {
      dataField: "user_name",
      text: "member info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div
              className="tb-flex"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  cardName: "follow-up",
                }))
              }
            >
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data tb-link">{row?.name || "NA"}</span>
            </div>

            {row?.mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">{row.mobile || "NA"}</span>
              </div>
            )}

            {row?.email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>
                <span className="tb-data lowercase">{row.email || "NA"}</span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 30;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "follow_up_number",
      text: "Current followup stage",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col tb-min-wid-80px">
            <span className="tb-data">{row?.follow_up_number || 0}</span>

            <span className="tb-data">
              {row?.followup_days_count || 0} time(S)
            </span>
          </div>
        );
      },
    },
    {
      dataField: "current_followup_status",
      text: "Last followup status",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">
              {row?.current_followup_status?.replace(/_/g, " ") || "NA"}
            </span>

            {row?.cutomer_intent && (
              <span
                className={`tb-data tb-txt-bold tb-txt-spaced ${
                  row.cutomer_intent?.toLowerCase() === "interested"
                    ? "tb-txt-success"
                    : row.cutomer_intent?.toLowerCase()?.replace(/ /g, "_") ===
                      "not_interested"
                    ? "tb-txt-danger"
                    : row.cutomer_intent?.toLowerCase() === "dnp" ||
                      row.cutomer_intent?.toLowerCase() === "re-churn"
                    ? "tb-txt-warning"
                    : "tb-txt-neutral"
                }`}
              >
                {row.cutomer_intent?.replace(/_/g, " ") || "-"}
              </span>
            )}

            {row?.next_followup_date && (
              <span className="tb-data">
                Next: {formatDateTime(row.next_followup_date)}
              </span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "lead_status",
      text: "lead status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-badge ${
              row?.lead_status === "converted"
                ? "tb-badge-success"
                : row?.lead_status === "pending"
                ? "tb-badge-success-1"
                : row?.lead_status === "closed"
                ? "not-assigned"
                : "tb-badge-success-2"
            }`}
          >
            {row?.lead_status === "pending"
              ? "Upcoming Followup"
              : row?.lead_status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "total_outgoing_call",
      text: "outgoing calls",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              Number(row?.total_outgoing_call || 0) > 0 ? "tb-link" : ""
            } tb-min-wid-50px`}
            onClick={() =>
              Number(row?.total_outgoing_call || 0) > 0 &&
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "total_outgoing_call",
              }))
            }
          >
            {row?.total_outgoing_call || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_outgoing_connected_call",
      text: "connected calls",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              Number(row?.total_outgoing_connected_call || 0) > 0
                ? "tb-link"
                : ""
            } tb-min-wid-50px`}
            onClick={() =>
              Number(row?.total_outgoing_connected_call || 0) > 0 &&
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "total_outgoing_connected_call",
              }))
            }
          >
            {row?.total_outgoing_connected_call || 0}
          </span>
        );
      },
    },
    {
      dataField: "added_by_name",
      text: "Added By",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <PersonIcon />
            </span>
            <span className="tb-data">{row?.added_by_name || "NA"}</span>
          </div>
        );
      },
    },
    {
      dataField: "assigned_to_name",
      text: "Assigned To",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data">{row?.assigned_to_name || "NA"}</span>
            </div>

            <span
              className={`tb-data tb-badge ${
                row?.assigned_to_status === "active"
                  ? "tb-badge-success"
                  : !row?.assigned_to_status ||
                    row?.assigned_to_status === "deleted"
                  ? "tb-badge-stuck"
                  : "tb-badge-success-2"
              }`}
            >
              {row?.assigned_to_status?.replace(/_/g, " ") || "deleted"}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "source_name",
      text: "source name",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">
              {row?.source_name?.replace(/_/g, " ") || "NA"}
            </span>
            <span className="tb-data tb-txt-bold tb-txt-spaced tb-txt-neutral underline">
              {!row?.utm_source
                ? "Organic"
                : row?.utm_source?.replace(/_/g, " ") || ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "is_raw_lead",
      text: "Lead From",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.lead_from === "lms" || row?.lead_from === "direct"
              ? "LMS (Directly Added From LMS)"
              : row?.lead_from === "expiring"
              ? "Renewal (Renewal and Expiring Members)"
              : row?.lead_from === "recurring"
              ? "Recurring (Recurring Members)"
              : row?.lead_from === "one_time_link"
              ? "One Time Payment Link"
              : row?.lead_from === "raw_lead"
              ? "RLMS (Raw Leads)"
              : row?.lead_from === "unpaid"
              ? "Unpaid (Unpaid Members)"
              : row?.lead_from?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (_, row) => {
        return (
          <div className="pp-employee-payroll-actions">
            <button
              key="view-lead-journey"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  cardName: "view-lead-journey",
                }))
              }
            >
              <EyeIcon />
              view
            </button>

            <button
              key="click-to-call"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  cardName: "click-to-call",
                }))
              }
            >
              <CallIcon />
              click to call
            </button>

            <button
              key="view-lead-journey"
              type="button"
              className={`pp-employee-payroll-action-button pp-outlined-border ${
                row?.lead_status?.toLowerCase() === "closed" ||
                row?.lead_status?.toLowerCase() === "converted"
                  ? "disabled"
                  : ""
              }`}
              disabled={
                row?.lead_status?.toLowerCase() === "closed" ||
                row?.lead_status?.toLowerCase() === "converted"
              }
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  cardName: "edit",
                }))
              }
            >
              <EditIcon1 />
              edit
            </button>

            {isAdmin && (
              <button
                key="view-lead-journey"
                type="button"
                className={`pp-employee-payroll-action-button pp-outlined-border ${
                  row?.lead_status?.toLowerCase() === "closed" ||
                  row?.lead_status?.toLowerCase() === "converted"
                    ? "disabled"
                    : ""
                }`}
                disabled={
                  row?.lead_status?.toLowerCase() === "closed" ||
                  row?.lead_status?.toLowerCase() === "converted"
                }
                onClick={(e) => {
                  const payload = {
                    lead_id: row?.lead_id,
                    status: "deleted",
                  };
                  handleDelete(payload);
                }}
              >
                <BinIcon1 />
                delete
              </button>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Edit Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            clickValues.cardName === "wap_image"
              ? "modal-container-abs"
              : clickValues.cardName === "re-assign" ||
                clickValues.cardName === "edit"
              ? "mod-width-50p"
              : clickValues.cardName === "follow-up"
              ? "followupSystemModal"
              : clickValues.cardName === "view_details"
              ? "add-new-lead-form"
              : clickValues.cardName === "view-lead-journey"
              ? "mod-height-95vh mod-width-70p"
              : clickValues.cardName === "click-to-call"
              ? "mod-height-95vh mod-width-70p p-0 m-0 bg-white"
              : ""
          } `}
        >
          {clickValues.cardName ===
          "click-to-call" ? null : clickValues.cardName === "follow-up" ? (
            <ModalCloseStart
              title="Manage Followup"
              onClose={() => {
                onCloseModal();
                callFunction();
              }}
            />
          ) : (
            <ModalHeadAndClose
              title={`${
                clickValues.cardName === "edit"
                  ? "Update Lead"
                  : clickValues.cardName === "follow-up"
                  ? "Manage Followup"
                  : clickValues.cardName === "re-assign"
                  ? "Re Assign Leads"
                  : clickValues.cardName === "wap_image"
                  ? clickValues.rowData?.name
                  : clickValues.cardName === "view-lead-journey"
                  ? `Lead Details - ${
                      clickValues.rowData?.user_name ||
                      clickValues.rowData?.name ||
                      ""
                    }`
                  : clickValues.cardName?.replace(/_/g, " ")
              }`}
              onClose={onCloseModal}
            />
          )}

          {clickValues.cardName === "edit" ? (
            <LeadEditForm
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              callFunction={callFunction}
              isEdit={true}
              rowData={clickValues.rowData}
              cardName={clickValues.cardName}
            />
          ) : clickValues.cardName === "follow-up" ? (
            <LeadFollowupV1
              userInfoData={userInfoData}
              rowData={clickValues.rowData}
              callFunction={callFunction}
              closeFollowupModal={onCloseModal}
              isAllLeadDetails={true}
              pageName="lms"
              prevFilters={prevFilters}
            />
          ) : clickValues.cardName === "re-assign" ? (
            <AssignForm
              userInfoData={userInfoData}
              selectedRows={selectedRows}
              closeModal={() => {
                callFunction();
                setSelectedRows([]);
                setIsAllSelected(false);
                onCloseModal();
                setAllDatas((prevState) => ({
                  ...prevState,
                  allLeads: prevState.allLeads.map((lead) => ({
                    ...lead,
                    checked: false,
                  })),
                }));
              }}
              isFromRawLead={true}
            />
          ) : clickValues.cardName === "total_outgoing_call" ||
            clickValues.cardName === "total_outgoing_connected_call" ? (
            <CallDetail
              userInfoData={userInfoData}
              rowData={clickValues.rowData}
              filterType={clickValues.cardName}
            />
          ) : clickValues.cardName === "wap_image" ? (
            <div className="discussionModalMessage mt30">
              <img src={clickValues.rowData?.wap_image} alt="profile" />
            </div>
          ) : clickValues.cardName === "view_details" ? (
            <LeadDetails rowData={clickValues.rowData} />
          ) : clickValues.cardName === "view-lead-journey" ? (
            <LeadJourney
              userInfoData={userInfoData}
              rowData={clickValues.rowData}
            />
          ) : clickValues.cardName === "click-to-call" ? (
            <ClickToCall
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              rowData={clickValues.rowData}
            />
          ) : null}
        </div>
      </Modal>

      <LeadTbCards stats_cards={allDatas.stats_cards} />

      {!isMarketing && !allLeadsLoading && (
        <div className="lms-select-actions-wrapper">
          <div className="lms-select-all-container">
            <input
              type="checkbox"
              id="lms-select-all-checkbox"
              className="lms-select-checkbox"
              onChange={(event) => handleToggleAllClick(event)}
              checked={isAllSelected}
              disabled={isAllSelectedDisabled}
            />

            {isAllSelectedDisabled ? (
              <span className="lms-select-info">
                All the leads either closed or converted
              </span>
            ) : (
              <label
                htmlFor="lms-select-all-checkbox"
                className="lms-select-label"
              >
                {isAllSelected
                  ? "Unselect All Table Data"
                  : "Select All Table Data"}
              </label>
            )}
          </div>

          {selectedRows?.length > 0 ? (
            <div className="lms-reassign-button-container">
              <button
                className="lms-reassign-btn"
                onClick={() =>
                  setClickValues({ isModOpen: true, cardName: "re-assign" })
                }
                disabled={selectedRows?.length === 0}
              >
                <ReloadIcon />
                Re Assign {selectedRows.length} Lead
                {selectedRows.length > 1 ? "s" : ""}
              </button>
            </div>
          ) : null}
        </div>
      )}

      <div className="common-table-container tb-bordered mt15">
        <CommonTable
          tableData={allDatas.allLeads}
          tablePagination={allDatas.pagination}
          tableColumns={tbColumns}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isLoading={allLeadsLoading}
          rowClassName={(row) => (row?.checked ? "tb-row-selected" : "")}
        />
      </div>

      {/* <div
        className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table"
        ref={tableRef}
      >
        {allLeadsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allLeads}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div> */}

      <div
        className="lead-logs-card-container only-mobile"
        ref={mobileTableRef}
      >
        {allLeadsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <LeadsLogsCard
            tableData={allDatas.allLeads}
            setClickValues={setClickValues}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            handleDelete={handleDelete}
            isLeadLoading={loading}
            userInfoData={userInfoData}
            handleCheckboxChange={handleCheckboxChange}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </>
  );
};

export default LeadLogsTable;
